// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"fead7181","366":"575f5b2b","542":"e347832d","787":"b0823f7d","922":"648caac6"}[chunkId] + ".chunk.js";
};